import apiClient from '@/plugins/apiClient'
let basePath = "cms/projects";
import qs from 'qs';

export default {
     namespaced: true,
     state:{
          list: [],
          single: null,
          errors: {},
          message: null,
          meta: {
               current_page: 1,
               total: 0,
               per_page: 12
          },
          filters: {
               wheres : []
          }
     },
     getters:{
          list: state => state.list,
          single: state => state.single,
          message: state => state.message,
          errors: state => state.errors,
          meta: state => state.meta,
          filters: state => state.filters,
     },
     mutations:{
        error(state, err) {
            console.log('mutation error',err);
            state.message = err.response.data.message
            state.errors = err.response.data.errors
        },
        setList(state, resp) {
            console.log('mutation setList',resp);
            state.list = resp.data;
        },
        setMeta(state, resp){
          console.log('mutation setMeta',resp.meta);
          state.meta = resp.meta
        },
        setSingle(state, resp){
          console.log('mutation setSingle',resp.data);
          state.single = resp.data
          state.errors = {}
          state.message = null
        },
        setProgectSingle(state, resp){
          console.log('mutation setSingle users',resp.data);
          state.single.users = resp.data
        }
     },
     actions:{
          getList({commit, state}, data){
               return new Promise((resolve, reject) => {
                    console.log('GET LIST STORES:'+data)
                    var params =  qs.stringify(state.filters, { arrayFormat: 'indices' })
                    apiClient.get(basePath+'?page='+state.meta.current_page+'&'+params).then(resp => {
                         commit('setList', resp.data);
                         commit('setMeta', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          createSingle({commit}, single){
               return new Promise((resolve, reject) => {
                    console.log('Create Single Project:'+single)
                    apiClient.post(basePath+'/create', single).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          getSingle({commit}, id){
               return new Promise((resolve, reject) => {
                    console.log('GET Single :'+id)
                    apiClient.get(basePath+'/'+id).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          updateSingle({commit}, project){
               return new Promise((resolve, reject) => {
                    console.log('GET Single project:', project)
                    apiClient.patch(basePath+'/'+project.id+'/update', project).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          deleteSingle({commit}, project){
               return new Promise((resolve, reject) => {
                    console.log('GET Single project:', project)
                    apiClient.delete(basePath+'/'+project.id+'/delete').then(resp => {
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          getUsers({commit}, project){
               return new Promise((resolve, reject) => {
                    console.log('GET Single project users:'+project.id)
                    apiClient.get(basePath+'/'+project.id+'/get-users').then(resp => {
                         commit('setProgectSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },

          addUser({commit}, data){
               return new Promise((resolve, reject) => {
                    console.log('ADD Single project users:'+data.project_id)
                    apiClient.post(basePath+'/'+data.project_id+'/add-user', data).then(resp => {
                         commit('setProgectSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('ADD SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          removeUser({commit}, data){
               return new Promise((resolve, reject) => {
                    console.log('REMOVE Single project users:'+data.project_id)
                    apiClient.post(basePath+'/'+data.project_id+'/remove-user', data).then(resp => {
                         commit('setProgectSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('REMOVE SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          createSiteExport({commit},data){
               return new Promise((resolve, reject) => {
                    console.log('Create Sit Export ', data)
                    apiClient.post(basePath+'/'+data.project_id+'/create-export').then(resp => {
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('REMOVE SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          importSingle({commit}, single){
               return new Promise((resolve, reject) => {
                    console.log('Import Single Project:'+single)
                    apiClient.post(basePath+'/import-project', single).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET SINGLE', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          setAsSingle({state}, data){
               state.single = data;
          },
          removeErrors({state}){
               state.errors = {};
               state.message = null;
          },
          setMeta({commit}, data){
               console.log('action meta',data);
               commit('setMeta',{meta:data});
               // commit('success', true);
          }
     },
}